import { io } from "socket.io-client";
let socket;

const connectSocket = async (userId, deviceId) => {
  return new Promise((resolve, reject) => {
    if (!socket || !socket?.connected) {
      socket = io(process.env.REACT_APP_PLEXAAR_CHATNCALL_API, {
        reconnectionDelay: 1000,
        reconnection: true,
        query: {
          userId: userId,
          deviceId,
        },
        reconnectionAttempts: 10,
        transports: ["websocket"],
        autoConnect: true,
        // agent: false,
        // upgrade: false,
        // rejectUnauthorized: false,
        // cors: {
        //   origin: "*",
        // },
      });

      socket.on("connect", () => {
        console.log("Socket connected successfully");
        console.log("UserID sent to the server:", socket.io.opts.query.userId);

        socket.on("online-users", (message) => {
          // Check if message is an array before using map
          if (Array.isArray(message)) {
            const userIdsArray = message
              .map((obj) => obj.userId) // Extract userIds
              .filter(
                (userId) =>
                  userId !== undefined && userId !== null && userId !== "null"
              ); // Filter out undefined or null values

            // Store userIdsArray in the local storage
            console.log("online11", JSON.stringify(userIdsArray));
            localStorage.setItem("userIdsArray", JSON.stringify(userIdsArray));
          } else {
            console.error(
              'Received "online-users" message is not an array:',
              message
            );
            // Handle the error or log it as needed
          }
        });

        resolve(socket); // Resolve the promise when socket is connected
      });

      // socket.on("disconnect", (reason) => {
      //   console.log("Socket disconnected. Reason:", reason);
      //   // You can perform any actions when the socket disconnects here
      // });

      socket.on("connect_error", (error) => {
        console.error("Connection error:", error);
        reject(error); // Reject the promise on connection error
        // You can add any custom error handling logic here
      });

      socket.on("prv_typing_message", (message) => {
        console.log("prv_typing_message", message);
      });
    } else {
      resolve(socket); // Resolve immediately if already connected
    }
  });
};

const getSocket = () => {
  return socket;
};

const disconnectSocket = () => {
  return socket.disconnect();
};

export { connectSocket, getSocket, disconnectSocket };
